import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Dresses from './pages/Dresses';
import Designers from './pages/Designers';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Settings from './pages/Settings';
import Locations from './pages/Locations';
import Categories from './pages/Categories';
import StaffManagement from './pages/StaffManagement';
import Profile from './pages/Profile';
import StyleMatcher from './pages/StyleMatcher';
import Reports from './pages/Reports';
import LikesReport from './pages/LikesReport';
import CustomerPreferenceReport from './pages/CustomerPreferenceReport';
import PageContent from './pages/PageContent';
import HomepageBanners from './pages/HomepageBanners';
import FeaturedDesignersManagement from './pages/FeaturedDesignersManagement';
import HomepageDressesManagement from './pages/HomepageDressesManagement';
import WebsiteContent from './pages/WebsiteContent';
import NewsletterSubscribers from './pages/NewsletterSubscribers';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="dresses" element={<Dresses />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="customers/:customerId/preferences" element={<CustomerPreferenceReport />} />
            <Route path="style-matcher" element={<StyleMatcher />} />
            <Route path="reports" element={<Reports />} />
            <Route path="reports/likes" element={<LikesReport />} />
            <Route path="profile" element={<Profile />} />
            <Route path="website" element={<WebsiteContent />}>
              <Route path="banners" element={<HomepageBanners />} />
              <Route path="featured-designers" element={<FeaturedDesignersManagement />} />
              <Route path="homepage-dresses" element={<HomepageDressesManagement />} />
              <Route path="page-content" element={<PageContent />} />
              <Route path="newsletter" element={<NewsletterSubscribers />} />
            </Route>
            <Route path="settings" element={<Settings />}>
              <Route path="designers" element={<Designers />} />
              <Route path="categories" element={<Categories />} />
              <Route path="staff" element={<StaffManagement />} />
              <Route path="locations" element={<Locations />} />
              <Route path="homepage-banners" element={<Navigate to="/website/banners" replace />} />
              <Route path="featured-designers" element={<Navigate to="/website/featured-designers" replace />} />
              <Route path="homepage-dresses" element={<Navigate to="/website/homepage-dresses" replace />} />
              <Route path="page-content" element={<Navigate to="/website/page-content" replace />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
